import { render, staticRenderFns } from "./questionRecord.vue?vue&type=template&id=7ff2edf4&scoped=true&"
import script from "./questionRecord.vue?vue&type=script&lang=ts&"
export * from "./questionRecord.vue?vue&type=script&lang=ts&"
import style0 from "./questionRecord.vue?vue&type=style&index=0&id=7ff2edf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff2edf4",
  null
  
)

export default component.exports